app.authorizeNet = {
  clientKey: null,
  apiLoginID: null
};
